import { createSlice } from "@reduxjs/toolkit";

export const dengueSettingSlice = createSlice({
    name: 'denguesetting',
    initialState: {
        area : "morbidity",
        patient: false,
        spotmap: false,
        cluster: false,
        co: false,
        nco: false
    },
    reducers: {
        setDengueArea: (state, action) => {
            state.area = action.payload;
            localStorage.setItem('trb-watch-setting', JSON.stringify({
                "1": {
                    ...state
                }
            }));
        },
        setDenguePatient: (state, action) => {
            state.patient = action.payload;
            localStorage.setItem('trb-watch-setting', JSON.stringify({
                "1": {
                    ...state
                }
            }));
        },
        setDengueSpotmap: (state, action) => {
            state.spotmap = action.payload;
            localStorage.setItem('trb-watch-setting', JSON.stringify({
                "1": {
                    ...state
                }
            }));
        },
        setDengueCluster: (state, action) => {
            state.cluster = action.payload;
            localStorage.setItem('trb-watch-setting', JSON.stringify({
                "1": {
                    ...state
                }
            }));
        },
        setDengueCo: (state, action) => {
            state.co = action.payload;
            localStorage.setItem('trb-watch-setting', JSON.stringify(state));
        },
        setDengueNco: (state, action) => {
            state.nco = action.payload;
            localStorage.setItem('trb-watch-setting', JSON.stringify({
                "1": {
                    ...state
                }
            }));
        },
        setDengueSetting: (state, action) => {
            state.area = action.payload.area;
            state.patient = action.payload.patient;
            state.spotmap = action.payload.spotmap;
            state.cluster = action.payload.cluster;
            state.co = action.payload.co;
            state.nco = action.payload.nco;
        }
    }
})

export const { setDengueArea, setDenguePatient, setDengueSpotmap, setDengueCluster, setDengueCo, setDengueNco, setDengueSetting } = dengueSettingSlice.actions;

export const getDengueSetting = (state) => state.denguesetting;
// export const getMapSettingHighlight = (state) => state.mapsetting.highlight;
// export const getMapSettingAreaName = (state) => state.mapsetting.areaname;

export default dengueSettingSlice.reducer;